import gql from 'graphql-tag'

export const generatePdfOrder = gql`
mutation generatePdfOrder($orderJson: JSON!) {
  cashAssist {
    generatePdfOrder(orderJson: $orderJson) {
        key
        url
        bucket
    }
  }
}
`
